import React from 'react';
import { Link } from 'react-router-dom';
import { Element } from 'react-scroll';

// icons
import FacebookIcon from '@material-ui/icons/Facebook';
import TwitterIcon from '@material-ui/icons/Twitter';
import InstagramIcon from '@material-ui/icons/Instagram';

const Footer = () => {
  return (
    <Element name='contact'>
      <div className='bg-footer'>
        <div className='container h-100 d-flex flex-column justify-content-end '>
          <div className='row'>
            <div className='col-lg-4 py-lg-3 text-white text-center'>
              <div className='text-center mx-auto ' style={{ width: 260 }}>
                <div>
                  <img
                    style={{ filter: 'invert(1)' }}
                    height={80}
                    src={
                      require('../../resources/logo-black.ico').default
                    }
                    alt='logo'
                    className='mw-100'
                  />
                </div>
                <h1 className='mt-2 mb-4'>OptionFalcon</h1>
                <div className='text-lg-center'>
                  <a
                    href='/'
                    target='_blank'
                    className='btn p-0 text-white mr-3'
                  >
                    <FacebookIcon />
                  </a>
                  <a
                    href='/'
                    target='_blank'
                    className='btn p-0 text-white mr-3'
                  >
                    G+
                  </a>
                  <a
                    href='/'
                    target='_blank'
                    className='btn p-0 text-white mr-3'
                  >
                    <TwitterIcon />
                  </a>
                  <a
                    href='/'
                    target='_blank'
                    className='btn p-0 text-white mr-3'
                  >
                    <InstagramIcon />
                  </a>
                </div>
              </div>
            </div>
            <div className='col-lg-4 py-3 text-white text-center small'>
              <div className='h-100 d-flex flex-column justify-content-end'>
                <ul className='list-unstyled d-flex align-items-center justify-content-around'>
                  <div className='text-left'>
                    <li className='mb-2'>
                      <Link className='text-white' to='/about'>
                        About
                      </Link>
                    </li>
                    <li className='mb-2'>
                      <Link className='text-white' to='/features'>
                        Features
                      </Link>
                    </li>
                    <li className='mb-2'>
                      <Link className='text-white' to='/faqs'>
                        FAQs
                      </Link>
                    </li>
                  </div>

                  <div className='text-left'>
                    {/* TODO to add prices */}
                    {/* <li className='mb-2'>
                      <Link className='text-white' to='/prices'>
                        Prices
                      </Link>
                    </li> */}
                    <li className='mb-2'>
                      <Link className='text-white' to='/report'>
                        Report
                      </Link>
                    </li>
                    <li className='mb-2'>
                      <Link className='text-white' to='/terms'>
                        Terms of Services
                      </Link>
                    </li>
                    <li className='mb-2'>
                      <Link className='text-white' to='/privacy'>
                        Privacy Policy
                      </Link>
                    </li>
                  </div>
                </ul>
              </div>
            </div>
            <div className='col-lg-4 py-3 text-white text-left'>
              <div className='h-100 d-flex flex-column justify-content-end ml-lg-5'>
                <h5 className='mb-3'>Contact</h5>
                <ul className='list-unstyled small'>
                  <li className='mb-2'>
                    {/* TODO add contact info */}
                    {/* info@flowsniper.com */}
                    {/* <Link className='text-white' to='/tos'>
                      Terms of Service
                    </Link> */}
                  </li>
                  {/* <li className='mb-2'>
                    <Link className='text-white' to='/privacy'>
                      Privacy Policy
                    </Link>
                  </li> */}
                </ul>
                <h6 className='mt-2'>Looking forward to hearing form you</h6>
              </div>
            </div>
          </div>
          <div className='small text-center text-white py-3'>
            Copyright &copy; 2021 OptionFalcon.com
          </div>
        </div>
      </div>
    </Element>
  );
};

export default Footer;
